module.exports = __webpack_public_path__ + "img/4f.9f19f195.png";